import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function UrgencySection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 10,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 59;
          hours -= 1;
        }
        if (hours < 0) {
          return {
            hours: 0,
            minutes: 0,
            seconds: 0
          };
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-white py-8 px-4" data-id="element-215">
      <div className="max-w-xl mx-auto" data-id="element-216">
        {/* Availability */}
        <div className="border border-mint-dark rounded-xl p-4 mb-4" data-id="element-217">
          <div className="flex items-center justify-between mb-2" data-id="element-218">
            <span className="text-gray-700 font-semibold flex items-center gap-1.5" data-id="element-219">
              <span className="text-lg" data-id="element-220">🔥</span> Accesos disponibles hoy
            </span>
            <span className="text-partyPink-hot font-black text-lg" data-id="element-221">
              3 restantes
            </span>
          </div>
          <div className="flex items-center gap-1.5 text-sm text-gray-500" data-id="element-222">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-223"></span>
            9 personas están viendo esto ahora mismo
          </div>
        </div>

        {/* Countdown */}
        <div className="border border-mint-dark rounded-xl p-5 text-center" data-id="element-224">
          <p className="text-partyPink-hot font-black text-sm uppercase tracking-wider mb-4 flex items-center justify-center gap-1.5" data-id="element-225">
            <span data-id="element-226">⚡</span> OFERTA ESPECIAL EXPIRA EN
          </p>

          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-227">
            <div className="flex flex-col items-center" data-id="element-228">
              <motion.div key={timeLeft.hours} initial={{
              scale: 1.15
            }} animate={{
              scale: 1
            }} className="bg-partyPink-hot text-white text-4xl md:text-5xl font-black w-20 h-20 md:w-24 md:h-24 rounded-xl flex items-center justify-center shadow-md" data-id="element-229">
                {pad(timeLeft.hours)}
              </motion.div>
              <span className="text-xs text-gray-500 font-semibold mt-1 uppercase" data-id="element-230">
                Horas
              </span>
            </div>

            <span className="text-3xl font-black text-partyPink-hot -mt-5" data-id="element-231">
              :
            </span>

            <div className="flex flex-col items-center" data-id="element-232">
              <motion.div key={timeLeft.minutes} initial={{
              scale: 1.15
            }} animate={{
              scale: 1
            }} className="bg-partyPink-hot text-white text-4xl md:text-5xl font-black w-20 h-20 md:w-24 md:h-24 rounded-xl flex items-center justify-center shadow-md" data-id="element-233">
                {pad(timeLeft.minutes)}
              </motion.div>
              <span className="text-xs text-gray-500 font-semibold mt-1 uppercase" data-id="element-234">
                Minutos
              </span>
            </div>

            <span className="text-3xl font-black text-partyPink-hot -mt-5" data-id="element-235">
              :
            </span>

            <div className="flex flex-col items-center" data-id="element-236">
              <motion.div key={timeLeft.seconds} initial={{
              scale: 1.15
            }} animate={{
              scale: 1
            }} className="bg-partyPink-hot text-white text-4xl md:text-5xl font-black w-20 h-20 md:w-24 md:h-24 rounded-xl flex items-center justify-center shadow-md" data-id="element-237">
                {pad(timeLeft.seconds)}
              </motion.div>
              <span className="text-xs text-gray-500 font-semibold mt-1 uppercase" data-id="element-238">
                Segundos
              </span>
            </div>
          </div>

          <p className="text-gray-500 text-sm font-medium flex items-center justify-center gap-1.5" data-id="element-239">
            <span data-id="element-240">🔒</span> Precio bloqueado en 13,99€ solo por hoy
          </p>
        </div>

        {/* Bottom CTA banner */}
        <div className="mt-4 bg-partyPink-hot rounded-xl py-3 px-6 text-center shadow-md" data-id="element-241">
          <p className="text-white font-bold text-base md:text-lg" data-id="element-242">
            🎉 Ahorra hasta un 60%{' '}
            <span className="font-black" data-id="element-243">¡Oferta válida hoy!</span>
          </p>
        </div>
      </div>
    </div>;
}